// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import md5 from 'js-md5'
import 'amfe-flexible/index'
import './assets/css/reset.css'
import './util/vanter.css'
// 按需引入vant
import{Button,Rate,Popup,Area,Tab,Tabs,Uploader,Icon,Toast,Field,DatetimePicker,Picker,SwipeCell,Overlay,Switch,Calendar,Progress,List,Checkbox,CheckboxGroup,RadioGroup, Radio } from 'vant'
Vue.use(Button);
Vue.use(Rate);
Vue.use(Popup);
Vue.use(Area);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Uploader);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(Overlay);
Vue.use(Switch);
Vue.use(Field);
Vue.use(DatetimePicker);
Vue.use(Picker);
Vue.use(SwipeCell);
Vue.use(Calendar);
Vue.use(Progress);
Vue.use(List);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.prototype.$md5 = md5;
Vue.config.productionTip = false;
import watchStroage from './util/watchStroage'
Vue.use(watchStroage)
// 为了解决setItemEvent不立即生效，使用事件派发强制更高
watchStroage.dispatchEventStroage();
import echarts from 'echarts'
Vue.prototype.$echarts = echarts;
// title动态加载
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js